import React from 'react';
import classnames from 'classnames/bind';
import { string, node, oneOfType, func } from 'prop-types';
import { ShowCaseConsumer } from '../ShowCase';

import styles from './Preview.css';
import colors from 'styles/_colors.css';

const Preview = ({ children, className, backgroundColor }) => {
  const previewClasses = classnames(
    styles.preview,
    className,
    'flex flex-justify-center flex-align-center'
  );

  const getStageStyles = (bgColor = backgroundColor) => ({
    backgroundColor: colors[bgColor] || bgColor || styles.backgroundColor
    // This fallbacks give us the ability to pass the bgColor argument as a Hex or as a colour variable
  });

  return (
    <ShowCaseConsumer>
      {({ selectedOptions, bgColor }) => (
          <div className={previewClasses} style={ getStageStyles(bgColor) }>
            {typeof(children) === 'function' ? children(selectedOptions) : children}
          </div>
        )
      }
    </ShowCaseConsumer>
  );
};

Preview.propTypes = {
  children: oneOfType([node, func]),
  selectKey: string,
  className: string,
  backgroundColor: string,
};

export default Preview;



// WEBPACK FOOTER //
// ./src/components/ShowCase/Preview/Preview.js